import React, { useState } from 'react';
import { planPorClave, montoCobro, fmtCobro, montoUsd, linkPaypal, reportarPagoManual, linkQuieroPlan } from '../services/membresiaService';
import { copiarTexto } from '../utils/compartir';
import { useToast } from '../context/ToastContext';

// Pagar un plan por transferencia o link de PayPal (sql/128): la dueña ve los
// datos de cobro, paga, sube la foto del comprobante y la admin lo aprueba.
export default function PagoManualModal({ plan, ciclo, moneda, fundador, promo = false, datos, negocioNombre, onCerrar, onEnviado }) {
  const { mostrarToast } = useToast();
  const p = planPorClave(plan);
  const cuentas = datos?.cuentas || [];
  const [metodo, setMetodo] = useState(cuentas.length ? 'transferencia' : 'paypal');
  const [archivo, setArchivo] = useState(null);
  const [referencia, setReferencia] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [listo, setListo] = useState(false);

  const monto = montoCobro(plan, ciclo, moneda, fundador, promo);
  const usd = montoUsd(monto, moneda);
  const esHnl = moneda === 'HNL';

  const copiar = async (texto) => {
    try { await copiarTexto(texto); mostrarToast('Copiado ✅', 'exito', 2000); } catch { /* sin portapapeles */ }
  };

  const enviar = async () => {
    if (!archivo) { mostrarToast('Sube la foto o captura del comprobante.', 'error'); return; }
    if (archivo.size > 15 * 1024 * 1024) { mostrarToast('El archivo es muy pesado (máximo 15 MB).', 'error'); return; }
    setEnviando(true);
    try {
      await reportarPagoManual({ plan, ciclo, metodo, referencia: referencia.trim(), archivo });
      setListo(true);
      onEnviado?.();
    } catch (e) {
      mostrarToast(e.message, 'error', 7000);
    } finally { setEnviando(false); }
  };

  const pestana = (clave, txt) => (
    <button key={clave} onClick={() => setMetodo(clave)}
      style={{ flex: 1, border: 'none', cursor: 'pointer', borderRadius: '999px', padding: '8px 10px', fontWeight: 700, fontFamily: 'inherit', fontSize: '13px',
        background: metodo === clave ? 'var(--color-primario,#6D28D9)' : 'transparent', color: metodo === clave ? '#fff' : '#4B5563' }}>
      {txt}
    </button>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1000 }}>
      <div className="k-card" style={{ padding: '20px', width: '100%', maxWidth: '440px', maxHeight: '92vh', overflowY: 'auto' }}>
        {listo ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '44px' }}>✅</div>
            <h3 style={{ margin: '6px 0' }}>¡Recibimos tu comprobante!</h3>
            <p style={{ color: '#374151', fontSize: '14px' }}>Lo revisamos y activamos tu plan {p?.nombre} en menos de 24 horas (normalmente el mismo día). Lo vas a ver aquí en Mi plan.</p>
            <button className="k-btn-ghost" onClick={onCerrar} style={{ marginTop: '8px' }}>Listo</button>
          </div>
        ) : (
          <>
            <h3 style={{ margin: '0 0 2px' }}>{p?.icono} Plan {p?.nombre} · {ciclo === 'anual' ? 'Anual' : 'Mensual'}</h3>
            <div style={{ fontSize: '28px', fontWeight: 800, color: '#1C1830' }}>
              {fmtCobro(monto, moneda)}
              {esHnl && <span style={{ fontSize: '13px', fontWeight: 600, color: '#6B7280', marginLeft: '8px' }}>≈ US${usd.toFixed(2)}</span>}
            </div>
            <p style={{ margin: '0 0 14px', fontSize: '12px', color: '#6B7280' }}>
              {ciclo === 'anual' ? 'Pago por 12 meses.' : 'Pago por 1 mes.'}{fundador ? ' 🏅 Con precio fundador.' : ''}{promo ? ' 🎉 Primer mes a mitad de precio (lanzamiento).' : ''}
            </p>

            {cuentas.length > 0 && datos?.paypal_usuario && (
              <div style={{ display: 'flex', background: '#F3F0FA', borderRadius: '999px', padding: '4px', marginBottom: '14px' }}>
                {pestana('transferencia', '🏦 Transferencia')}
                {pestana('paypal', '💳 PayPal / tarjeta')}
              </div>
            )}

            <b style={{ display: 'block', fontSize: '14px', marginBottom: '6px' }}>1. Paga</b>
            {metodo === 'transferencia' ? (
              <div style={{ display: 'grid', gap: '8px', marginBottom: '8px' }}>
                {cuentas.map((c, i) => (
                  <div key={i} style={{ border: '1px solid #E9E3F5', borderRadius: '12px', padding: '10px 12px', fontSize: '14px' }}>
                    <b>{c.banco}</b>{c.tipo ? ` · ${c.tipo}` : ''}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '2px' }}>
                      <span style={{ fontFamily: 'DM Mono, monospace', fontSize: '16px', fontWeight: 700 }}>{c.numero}</span>
                      <button className="k-btn-soft" style={{ fontSize: '12px', padding: '3px 10px' }} onClick={() => copiar(c.numero)}>Copiar</button>
                    </div>
                    {c.titular && <div style={{ color: '#6B7280', fontSize: '13px' }}>A nombre de {c.titular}</div>}
                  </div>
                ))}
                <p style={{ margin: 0, fontSize: '12px', color: '#6B7280' }}>En la descripción de la transferencia pon: <b>Kontrol {negocioNombre || ''}</b></p>
              </div>
            ) : (
              <div style={{ marginBottom: '8px' }}>
                <a href={linkPaypal(datos.paypal_usuario, usd)} target="_blank" rel="noopener noreferrer"
                  style={{ display: 'block', textAlign: 'center', textDecoration: 'none', background: '#0070BA', color: '#fff', borderRadius: '10px', padding: '11px', fontWeight: 700 }}>
                  Pagar US${usd.toFixed(2)} con PayPal
                </a>
                <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#6B7280' }}>Se abre PayPal con el monto listo. Puedes pagar con tu cuenta PayPal o con tarjeta. Al terminar, toma captura de la pantalla de pago.</p>
              </div>
            )}
            {datos?.instrucciones && <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#374151' }}>ℹ️ {datos.instrucciones}</p>}

            <b style={{ display: 'block', fontSize: '14px', margin: '14px 0 6px' }}>2. Sube tu comprobante</b>
            <label style={{ display: 'block', border: '2px dashed #D8CCF0', borderRadius: '12px', padding: '14px', textAlign: 'center', cursor: 'pointer', fontSize: '14px', color: archivo ? '#047857' : '#6B7280', fontWeight: 600 }}>
              {archivo ? `📎 ${archivo.name}` : '📷 Toca para elegir la foto o captura'}
              <input type="file" accept="image/*,application/pdf" style={{ display: 'none' }} onChange={(e) => setArchivo(e.target.files?.[0] || null)} />
            </label>
            <input className="k-input" value={referencia} onChange={(e) => setReferencia(e.target.value)} maxLength={60}
              placeholder="Número de referencia (opcional)" style={{ marginTop: '8px' }} />

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
              <button className="k-btn-soft" onClick={onCerrar} disabled={enviando}>Cancelar</button>
              <button className="k-btn-ghost" onClick={enviar} disabled={enviando || !archivo}>{enviando ? 'Enviando…' : 'Enviar comprobante'}</button>
            </div>
            <a href={linkQuieroPlan({ negocioNombre, plan, ciclo, moneda, fundador })} target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', textAlign: 'center', marginTop: '12px', fontSize: '13px', color: '#6B7280' }}>
              ¿Dudas? Escríbenos por WhatsApp
            </a>
          </>
        )}
      </div>
    </div>
  );
}
